import { damageTypes, preventionSteps } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function DamageTypesSection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="flex-1">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950">
                자주 발생하는 피해 유형
              </h2>
              <Link
                to="/board"
                className="text-xs text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap"
              >
                더보기
                <i className="ri-arrow-right-s-line" />
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {damageTypes.map((item) => (
                <div
                  key={item.title}
                  className="bg-white rounded-lg p-4 border border-background-200 hover:border-primary-300 transition-colors text-center"
                >
                  <div className="w-12 h-12 mx-auto rounded-full bg-secondary-50 flex items-center justify-center mb-3">
                    <i className={`${item.icon} text-secondary-600 text-xl`} />
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-80">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-lg md:text-xl font-bold text-foreground-950">
                먹튀 안 당하는 방법
              </h2>
              <Link
                to="/search"
                className="text-xs text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap"
              >
                더보기
                <i className="ri-arrow-right-s-line" />
              </Link>
            </div>
            <div className="bg-white rounded-lg border border-background-200 p-5">
              <ol className="space-y-3">
                {preventionSteps.map((step, idx) => (
                  <li key={step} className="flex items-start gap-3">
                    <span className="w-6 h-6 rounded-full bg-primary-500 text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                    <span className="text-sm text-foreground-700 leading-relaxed">{step}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}